import ErrorPage from "@/components/pages/ErrorPage";
import ConsentDialog from "@/features/consent/ConsentDialog";
import {
	diaryByIdQueryOptions,
	useDiaryByIdQuery,
} from "@/features/diaries/api";
import DiaryTitle from "@/features/diaries/components/DiaryTitle";
import DiaryViewTabs from "@/features/diaries/components/DiaryViewTabs";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import DiaryProgressMessage from "../../../../features/diaries/components/DiaryProgressMessage";

const Home = () => {
	const { diaryId } = Route.useParams();
	const { data: diary, isFetching, isLoading } = useDiaryByIdQuery(diaryId);

	if (isLoading) {
		return null;
	}

	return (
		<section className="md-width">
			{diary && <DiaryTitle diary={diary} editing={false} />}
			<div className="flex flex-col gap-y-4">
				<ConsentDialog diaryId={diaryId} isLoading={isFetching} />
			</div>
			<div className="flex flex-col gap-y-4 my-4 w-md">
				<DiaryViewTabs diary={diary} />
				<DiaryProgressMessage diary={diary} />
			</div>
			<Outlet />
		</section>
	);
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home")({
	component: Home,
	errorComponent: ({ error, reset }) => (
		<ErrorPage error={error as Error} reset={reset} />
	),
	loader: async ({ context, params }) => {
		const diary = await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
		return { diary };
	},
});
